// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttons[data-v-b25ae966]{display:-webkit-box;display:-ms-flexbox;display:flex}h2[data-v-b25ae966],p[data-v-b25ae966]{text-align:center}p[data-v-b25ae966]{padding:20px;font-size:18px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
